// extracted by css-extract-rspack-plugin
export default {"includeMedicalCheckbox":"includeMedicalCheckbox-kxVtNS"};